import { IHisInfoItemBehavior } from "./IHisInfoItemBehavior";
import { HisInformationItem } from "../..";
import { HisInformationDateTimeValue } from "../../HisInformationValue";
import { DateTimeStringUtility } from "../../../system/DateTimeStringUtility";

/** HIS項目 指定された日付を生成する(項目が無い場合は空) */
export class DefaultCreateDateBehavior implements IHisInfoItemBehavior {
  constructor(private key: string, private defaultDateFormat?: string) {}
  
  getValue(hisInfoItems: HisInformationItem[]): HisInformationDateTimeValue {
    const values =  hisInfoItems.filter(x => x.name === this.key).map(x => x.value);
    const dateValues = values
      .filter(x => !DateTimeStringUtility.isEmptyDate(x))
      .filter(x => DateTimeStringUtility.isDateFormat(x))
      .map(x => DateTimeStringUtility.toDateValue(x));
    return new HisInformationDateTimeValue(this.key, dateValues, this.defaultDateFormat);
  }
}
